export function focusQuestionDescription() {
  const descriptionElement = document.getElementById('question-description');
  if (descriptionElement) {
    descriptionElement.focus();
  }
}
